import React, { useRef, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({info}) => {
  const chartRef = useRef(null);
  const {transactions} = info



  
  const groupLogByMonths = (deposits) => {
    return deposits?.reduce((dep, event) => {
      const eventDate = new Date(event?.transactionValueDate);
      const month = eventDate.toLocaleString('default', { month: 'long' }); // Get full month name (e.g., "November")
      
      if (!dep[month]) {
        dep[month] = [];
      }
      dep[month].push(event);
      return dep;
    }, {});
  };
  
  const trans = groupLogByMonths(transactions);
  // const getWithByMonths = groupLogByMonths(withdrawal);

  // console.log(trans);



  let months = []
  function formatDate(date) {

    date = new Date(date);
    var monthIndex = date.toLocaleString('default', { month: 'long' });

    return monthIndex 
}

  for ( let i=11; i>=0; i--) {
      let now = new Date();
      let newdate = now.setMonth(now.getMonth() - i);
      // console.log(formatDate(newdate ));
      months.push(formatDate(newdate))
  }

  useEffect(() => {
    const chart = chartRef.current;
  }, []);

  const data = {
    labels: months,
    datasets: [
      {
        label: "Number of Transactions",
        tension: 0.4,
        borderWidth: 0,
        borderRadius: 4,
        borderSkipped: false,
        backgroundColor: "rgba(255, 255, 255)",
        data: [ trans?.February?.length, trans?.March?.length, trans?.April?.length, trans?.May?.length, trans?.June?.length, trans?.July?.length, trans?.August?.length, trans?.September?.length, trans?.October?.length, trans?.November?.length, trans?.December?.length, trans?.January?.length,],
        maxBarThickness: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `Transactions: ${context.parsed.y.toLocaleString()}`;
          },
        },
      },
    },
    // interaction: {
    //   intersect: false,
    //   mode: "index",
    // },
    scales: {
      y: {
        grid: {
          drawBorder: false,
          display: true,
          drawOnChartArea: true,
          drawTicks: false,
          borderDash: [5, 5],
          // color: "rgba(255, 255, 255,0.8)",
        },
        ticks: {
          suggestedMin: 0,
          suggestedMax: 6000,
          beginAtZero: true,
          padding: 10,
          font: {
            size: 14,
            family: "Open Sans",
            style: "normal",
            lineHeight: 2,
          },
          color: "#fff",
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
          drawOnChartArea: false,
          drawTicks: false,
        },
        ticks: {
          display: true,
          color: "#fff",
          padding: 20,
          font: {
            size: 12,
            family: "Open Sans",
            style: "normal",
          },
        },
      },
    },
  };

  return <Bar ref={chartRef} data={data} options={options} />;
};

export default BarChart;
